import { Component } from '@angular/core';
import { selectUpdatePermissions } from '../../application.selector';
import { ApplicationsState } from '../../applications.state';
import { BsModalService } from 'ngx-bootstrap';
import { Store } from '@ngrx/store';
import { ContainerComponent } from '../../../shared/components/container-component/unsubscribe.component';
import { UpdatePermissionsDialogComponent } from '../update-permissions-dialog/update-permissions-dialog.component';
import * as updateActions from '../../actions/application-update-permissions.actions';

import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/filter';

/**
 * Component displays enabled application list.
 */
@Component({
    selector: 'ssf-manage-applications',
    template: require('./manage-applications.component.html')
})
export class ManageApplicationsComponent extends ContainerComponent {
    private fullscreenModalConf = Object.assign({}, {class: 'ssf-modal_fullscreen-wrapper', ignoreBackdropClick: false});
    public i18n = 'APPLICATIONS.MANAGE-APPLICATIONS.';

    constructor(private store: Store<ApplicationsState>, private modalService: BsModalService) {
        super();

        // -------------------------------------------------------------------------------------------------------------

        this.store.select(selectUpdatePermissions)
            .takeUntil(this.ngUnsubscribe)
            .filter((value) => value  &&  value.shown)
            .subscribe(() => this.modalService.show(UpdatePermissionsDialogComponent, this.fullscreenModalConf));

        this.modalService.onHide
            .takeUntil(this.ngUnsubscribe)
            .filter((reason: string) => !!reason) // only for esc button - reason === `esc`; close button fires ClosePopupAction too
            .subscribe(() => this.store.dispatch(new updateActions.UpdatePermissionsCancelAction()));

        // -------------------------------------------------------------------------------------------------------------

    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/manage-applications/manage-applications.component.ts